import { render } from "./stock-transfer-details-report.vue?vue&type=template&id=59d1c2f0"
import script from "./stock-transfer-details-report.vue?vue&type=script&lang=js"
export * from "./stock-transfer-details-report.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__